import { render, staticRenderFns } from "./CoreEdit.vue?vue&type=template&id=f337feaa&"
import script from "./CoreEdit.vue?vue&type=script&lang=js&"
export * from "./CoreEdit.vue?vue&type=script&lang=js&"
import style0 from "./CoreEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports